export const messages = {
  en: {
    workDetail: {
      title: 'Work Order Details',
      workId: 'Work Order ID',
      workName: 'Work Order Name',
      typeName: 'Type Name',
      workCycle: 'Mark',
      once: 'One-time Work Order',
      periodic: 'Periodic Work Order',
      startTime: 'Start Time',
      endTime: 'End Time',
      createUserName: 'Initiator',
      curStaffName: 'Handler',
      curCopyName: 'Copy Person',
      stateName: 'Status',
      createTime: 'Create Time',
      attachment: 'Attachment',
      content: 'Content',
      handler: 'Handler',
      handlerContent: 'Handler Content',
      copyPerson: 'Copy Person',
      workFlow: 'Work Order Flow',
      flowAttachment: 'Flow Attachment',
      workType: 'Work Order Type',
      workCycleTab: 'Work Order Cycle'
    },
    workDetailTask: {
      taskId: 'Task ID',
      staffName: 'Handler',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      stateName: 'Status',
      operation: 'Operation',
      progress: 'Progress',
      staffNamePlaceholder: 'Please enter handler',
      startTimePlaceholder: 'Start time',
      endTimePlaceholder: 'End time'
    },
    workDetailTaskItem: {
      content: 'Work Content',
      finishTime: 'Finish Time',
      state: 'Status',
      remark: 'Remark',
      attachment: 'Attachment',
      score: 'Score',
      deductionMoney: 'Deduction Amount',
      deductionReason: 'Deduction Reason',
      deductionPerson: 'Deduction Person',
      createTime: 'Create Time',
      copyProcessed: 'Copy Person Processed',
      handlerProcessed: 'Handler Processed',
      pending: 'Pending'
    },
    workDetailCopy: {
      copyId: 'Task ID',
      staffName: 'Copy Person',
      createTime: 'Create Time',
      stateName: 'Status',
      remark: 'Remark',
      staffNamePlaceholder: 'Please enter copy person'
    },
    workDetailEvent: {
      preStaffName: 'Previous Handler',
      staffName: 'Handler',
      taskValidPeriod: 'Task Valid Period',
      remark: 'Remark',
      createTime: 'Time',
      staffNamePlaceholder: 'Please enter handler',
      startTimePlaceholder: 'Start time',
      endTimePlaceholder: 'End time'
    },
    workDetailFile: {
      staffName: 'Handler',
      attachment: 'Attachment',
      staffNamePlaceholder: 'Please enter handler',
      startTimePlaceholder: 'Start time',
      endTimePlaceholder: 'End time'
    },
    workDetailType: {
      typeName: 'Type Name',
      notifyWay: 'Notification Method',
      createTime: 'Create Time',
      remark: 'Remark',
      wechat: 'WeChat',
      aliSms: 'Ali SMS',
      unknown: 'Unknown'
    },
    workDetailCycle: {
      staffName: 'Handler',
      workCycle: 'Mark',
      hours: 'Completion Hours',
      period: 'Cycle',
      month: 'Month',
      day: 'Day',
      week: 'Week',
      once: 'One-time Work Order',
      periodic: 'Periodic Work Order',
      monthDay: 'Month/Day',
      weekly: 'Weekly'
    }
  },
  zh: {
    workDetail: {
      title: '工作单详情',
      workId: '日志编号',
      workName: '日志名称',
      typeName: '类型名称',
      workCycle: '标识',
      once: '一次性日志',
      periodic: '周期性日志',
      startTime: '开始时间',
      endTime: '结束时间',
      createUserName: '发起人',
      curStaffName: '处理人',
      curCopyName: '抄送人',
      stateName: '状态',
      logType: '日志类型',
      workPlan: '明日工作计划',
      problemsEncountered: '遇到的问题',
      createTime: '创建时间',
      attachment: '附件',
      content: '内容',
      handler: '处理人',
      handlerContent: '处理内容',
      copyPerson: '抄送人',
      workFlow: '工作单流转',
      flowAttachment: '流转附件',
      workType: '工作单类型',
      workCycleTab: '工作单周期'
    },
    workDetailTask: {
      taskId: '任务编号',
      staffName: '处理人',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      stateName: '状态',
      operation: '操作',
      progress: '进度',
      staffNamePlaceholder: '请填写处理人',
      startTimePlaceholder: '开始时间',
      endTimePlaceholder: '结束时间'
    },
    workDetailTaskItem: {
      content: '工作内容',
      finishTime: '完成时间',
      state: '状态',
      remark: '说明',
      attachment: '附件',
      score: '评分',
      deductionMoney: '扣款金额',
      deductionReason: '扣款原因',
      deductionPerson: '扣款人',
      createTime: '创建时间',
      copyProcessed: '抄送人已办理',
      handlerProcessed: '处理人已办理',
      pending: '待处理'
    },
    workDetailCopy: {
      copyId: '任务编号',
      staffName: '抄送人',
      createTime: '创建时间',
      stateName: '状态',
      remark: '说明',
      staffNamePlaceholder: '请填写抄送人'
    },
    workDetailEvent: {
      preStaffName: '前处理人',
      staffName: '处理人',
      taskValidPeriod: '任务有效期',
      remark: '说明',
      createTime: '时间',
      staffNamePlaceholder: '请填写处理人',
      startTimePlaceholder: '开始时间',
      endTimePlaceholder: '结束时间'
    },
    workDetailFile: {
      staffName: '处理人',
      attachment: '附件',
      staffNamePlaceholder: '请填写处理人',
      startTimePlaceholder: '开始时间',
      endTimePlaceholder: '结束时间'
    },
    workDetailType: {
      typeName: '类型名称',
      notifyWay: '通知方式',
      createTime: '创建时间',
      remark: '备注',
      wechat: '微信',
      aliSms: '阿里短信',
      unknown: '未知'
    },
    workDetailCycle: {
      staffName: '处理人',
      workCycle: '标识',
      hours: '完成小时',
      period: '周期',
      month: '月',
      day: '日',
      week: '周',
      once: '一次性日志',
      periodic: '周期性日志',
      monthDay: '月/天',
      weekly: '按周'
    }
  }
}